// Central content + image data for the MEDTREND landing page

export const img = (id, w = 1200) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
  heroInstruments: '1688565631957-0306970fdd74',
  heroInstruments2: '1668453598237-27098d2575ac',
  instrumentsFlat: '1579154204601-01588f351e67',
  surgeryTeam: '1685997179880-6449203a053e',
  surgeryHands: '1551190822-a9333d879b1f',
  surgeryTools: '1640876777002-badf6aee5bcc',
  cnc1: '1666634157070-6fd830fb5672',
  cnc2: '1666618090858-fbcee636bd3e',
  cnc3: '1532186773960-85649e5cb70b',
  factory1: '1631815589968-fdb09a223b1e',
  factory2: '1666214280557-f1b5022eb634',
  hospital1: '1719934398679-d764c1410770',
  hospital2: '1758691462848-ba1e929da259',
  lab1: '1581595220892-b0739db3ba8c',
  lab2: '1512678080530-7760d81faba6',
  team1: '1587854692152-cbe660dbde88',
  clinic: '1576091160399-112ba8d25d1d',
  micro: '1519494026892-80bbd2d6fd0d',
  steel: '1583324113626-70df0f4deaab',
  polish: '1583911860205-72f8ac8ddcbe',
  inspect: '1559757148-5c350d0d3c56',
  scalpel: '1584982751601-97dcc096659c',
};

export const NAV = [
  { label: 'Home', href: '#home' },
  { label: 'Products', href: '#products' },
  { label: 'OEM Manufacturing', href: '#manufacturing' },
  { label: 'Quality', href: '#quality' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
];

export const LANGUAGES = [
  { code: 'EN', label: 'English' },
  { code: 'DE', label: 'Deutsch' },
  { code: 'FR', label: 'Français' },
  { code: 'AR', label: 'العربية' },
  { code: 'ES', label: 'Español' },
];

export const HERO_BADGES = [
  'ISO 13485',
  'CE Certified',
  'OEM Manufacturer',
  'Worldwide Export',
  'Premium Stainless Steel',
  '25+ Years Experience',
];

export const COUNTERS = [
  { value: 25, suffix: '+', label: 'Years of Excellence' },
  { value: 70, suffix: '+', label: 'Countries Served' },
  { value: 5000, suffix: '+', label: 'Product Variants' },
  { value: 100000, suffix: '+', label: 'Global Customers' },
  { value: 100, suffix: '%', label: 'Stainless Steel' },
];

export const CATEGORIES = [
  { name: 'Orthopedic', count: 820, id: IMAGES.instrumentsFlat },
  { name: 'Dental', count: 640, id: IMAGES.lab1 },
  { name: 'ENT', count: 410, id: IMAGES.surgeryTools },
  { name: 'Plastic Surgery', count: 520, id: IMAGES.scalpel },
  { name: 'General Surgery', count: 980, id: IMAGES.surgeryHands },
  { name: 'Gynecology', count: 360, id: IMAGES.clinic },
  { name: 'Veterinary', count: 290, id: IMAGES.micro },
  { name: 'Neurosurgery', count: 470, id: IMAGES.lab2 },
];

export const PROCESS = [
  { step: '01', title: 'Steel Selection', id: IMAGES.steel, desc: 'German 420 & 316L surgical-grade stainless steel sourced to spec.' },
  { step: '02', title: 'Forging', id: IMAGES.factory1, desc: 'Precision drop-forging for superior structural integrity.' },
  { step: '03', title: 'Grinding', id: IMAGES.cnc1, desc: 'CNC grinding calibrated to micron-level tolerances.' },
  { step: '04', title: 'Polishing', id: IMAGES.polish, desc: 'Mirror & satin finishes engineered for sterility.' },
  { step: '05', title: 'Inspection', id: IMAGES.inspect, desc: 'Dimensional & hardness verification at every batch.' },
  { step: '06', title: 'Laser Marking', id: IMAGES.cnc2, desc: 'Permanent UDI-compliant laser traceability marking.' },
  { step: '07', title: 'Cleaning', id: IMAGES.lab2, desc: 'Ultrasonic passivation & contamination removal.' },
  { step: '08', title: 'Packaging', id: IMAGES.factory2, desc: 'Sterile-ready medical packaging & labeling.' },
  { step: '09', title: 'Export', id: IMAGES.cnc3, desc: 'Container loading & documentation for 70+ countries.' },
];

export const FEATURED = [
  { name: 'Titanium Micro Needle Holder', category: 'Neurosurgery', id: IMAGES.instrumentsFlat, tag: 'New' },
  { name: 'Adson Tissue Forceps', category: 'General Surgery', id: IMAGES.surgeryTools, tag: 'Best Seller' },
  { name: 'Mayo Curved Scissors', category: 'General Surgery', id: IMAGES.scalpel, tag: 'Premium' },
  { name: 'Diamond-Dust Needle Driver', category: 'Plastic Surgery', id: IMAGES.surgeryHands, tag: 'Pro' },
];

export const WHY = [
  { icon: 'Crosshair', title: 'Precision Engineering', desc: 'Micron-level CNC tolerances and hand-finishing by master craftsmen.' },
  { icon: 'Factory', title: 'OEM Manufacturing', desc: 'Full private-label production with your branding, packaging and specs.' },
  { icon: 'Globe2', title: 'Global Distribution', desc: 'Reliable export logistics reaching 70+ countries on six continents.' },
  { icon: 'ShieldCheck', title: 'Quality Assurance', desc: 'ISO 13485 & CE certified with 100% batch-level inspection.' },
];

export const QC_STEPS = [
  { title: 'Incoming Material Inspection', desc: 'Certified steel verified for composition & hardness before production.' },
  { title: 'Precision Testing', desc: 'Dimensional metrology against master gauges at micron tolerance.' },
  { title: 'Surface Finishing', desc: 'Passivation and finish validation for sterility & corrosion resistance.' },
  { title: 'Final Inspection', desc: 'Functional and cosmetic QC on every single instrument.' },
  { title: 'Sterilization', desc: 'Validated cleaning and sterile-barrier preparation.' },
  { title: 'Packaging', desc: 'Medical-grade packaging with full UDI traceability.' },
  { title: 'Shipping', desc: 'Documented, insured global export to your facility.' },
];

export const EXPORT_HUBS = [
  { country: 'USA', x: 22, y: 40, info: 'FDA-compliant supply · 1,200+ distributors' },
  { country: 'Canada', x: 21, y: 30, info: 'Cross-border OEM programs' },
  { country: 'UK', x: 45, y: 33, info: 'CE & UKCA certified exports' },
  { country: 'Germany', x: 49, y: 34, info: 'European distribution hub' },
  { country: 'Saudi Arabia', x: 57, y: 47, info: 'GCC medical procurement partner' },
  { country: 'Australia', x: 82, y: 78, info: 'TGA-aligned instrument supply' },
];

export const TESTIMONIALS = [
  {
    name: 'Dr. Andreas Vogt',
    role: 'Procurement Director',
    company: 'MediCore GmbH',
    country: 'Germany',
    flag: '🇩🇪',
    quote:
      'MEDTREND consistently delivers instruments with tolerances our surgeons trust. Their OEM program transformed our product line.',
  },
  {
    name: 'Sarah Whitmore',
    role: 'VP Supply Chain',
    company: 'Apex Surgical',
    country: 'USA',
    flag: '🇺🇸',
    quote:
      'Flawless finishing, on-time export, and documentation that clears customs without friction. A rare manufacturing partner.',
  },
  {
    name: 'Faisal Al-Harbi',
    role: 'General Manager',
    company: 'Gulf Medico',
    country: 'Saudi Arabia',
    flag: '🇸🇦',
    quote:
      'The precision and mirror polish quality are simply unmatched in the region. Our clients notice the difference instantly.',
  },
  {
    name: 'James Carter',
    role: 'Founder',
    company: 'NorthMed Distributors',
    country: 'Canada',
    flag: '🇨🇦',
    quote:
      'From steel selection to laser marking, the transparency of their process gives us total confidence in every shipment.',
  },
];

export const BLOG = [
  { title: 'The Science Behind Surgical-Grade Stainless Steel', tag: 'Materials', id: IMAGES.steel, date: 'Mar 2025' },
  { title: 'Why UDI Laser Marking Matters for Global Compliance', tag: 'Compliance', id: IMAGES.cnc2, date: 'Feb 2025' },
  { title: 'Inside a Modern OEM Instrument Manufacturing Line', tag: 'Manufacturing', id: IMAGES.factory1, date: 'Jan 2025' },
];

export const CERTS = ['ISO 13485', 'CE MARKED', 'FDA REGISTERED', 'ISO 9001', 'GMP COMPLIANT'];
